import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const fortniteWeaponsModel = {
  id: String,
  name: String,
  key: String,
  rarity: String,
} satisfies ModelDefinition;

export const FortniteWeaponsModel = createModel({
  data: { weapons: [fortniteWeaponsModel] },
}).transform([fortniteWeaponsModel], (data) => data.data.weapons);

export type FortniteWeapon = FromModel<typeof fortniteWeaponsModel>;
export type FortniteWeapons = FromModel<typeof FortniteWeaponsModel>;

export default FortniteWeaponsModel;
